module.exports = __webpack_public_path__ + "img/broken_heart.f4b290a3.png";